var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-progress',{attrs:{"max":_vm.max,"show-progress":"","show-value":""}},[_c('b-progress-bar',{attrs:{"value":_vm.value}},[_c('span',{staticClass:"progress-bar__value"},[_vm._v(_vm._s(_vm.value))])]),_c('div',{staticClass:"progress-bar__max"},[_vm._v(_vm._s(_vm.max))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }